"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  REGULAR: 0,
  SIMPLE: 1,
  ONLY_ICON: 2,
  ONLY_TITLE: 3
};
exports.DEFAULT_VIEW = 1;